/** Default home after login by backend role slug. */
import { isCrmRole } from './crmPermissions';

export const SUBSCRIPTION_GATE_ALLOWED_PREFIXES = [
  '/settings/subscription',
];

export function needsSubscriptionGate(user) {
  if (!user || user.role_slug !== 'school_admin' || user.school_observer_mode) {
    return false;
  }
  return (user.subscription?.status ?? 'none') === 'none';
}

export function isSubscriptionGateAllowedPath(pathname) {
  if (!pathname) return false;
  return SUBSCRIPTION_GATE_ALLOWED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function getPostLoginPath(roleSlug, user = null) {
  const r = roleSlug != null ? String(roleSlug).toLowerCase().trim() : '';
  if (isCrmRole(user || r)) return '/crm/dashboard';
  if (r === 'receptionist') return '/reception';
  if (r === 'school_admin' && needsSubscriptionGate(user)) {
    return '/settings/subscription/upgrade';
  }
  return '/dashboard';
}

export function isSchoolModuleRole(roleSlug) {
  return roleSlug === 'super_admin';
}

export function isSoftwareModuleRole(roleSlug) {
  return false;
}

/** CRM inquiries access for all CRM roles. */
export function canAccessEnquiries(roleSlugOrUser) {
  return isCrmRole(roleSlugOrUser);
}

/** Roles that use per-school sidebar modules (classes, students, etc.). */
export function isSchoolOperationalRole(roleSlug) {
  const r = roleSlug != null ? String(roleSlug).toLowerCase().trim() : '';
  return ['school_admin', 'principal', 'teacher', 'student', 'parent', 'staff', 'receptionist'].includes(r);
}

/** Staff ERP roles — collapsible nav groups filtered by permissions. */
export function isSchoolStaffRole(roleSlug) {
  const r = roleSlug != null ? String(roleSlug).toLowerCase().trim() : '';
  return ['school_admin', 'principal', 'teacher', 'staff', 'receptionist'].includes(r);
}

/** Student/parent portal — flat permission-based nav. */
export function isPortalRole(roleSlug) {
  const r = roleSlug != null ? String(roleSlug).toLowerCase().trim() : '';
  return r === 'student' || r === 'parent';
}

/** Class teacher + secondary assignment (Class detail → Sections). */
export { canAssignClassTeachers } from './featurePermissions';
